import React, { useState } from "react";
import Modal from "../component.js/Modal";
import { University } from "../component.js/data";
import { LSSB } from "../utils/LSSB_live";
import { useQuery } from "@tanstack/react-query";
import { ProfileCircle } from "iconsax-react";

const MyProfile = () => {
  const [isOpen, setIsOpen] = useState(false);

  const handleCloseModal = () => {
    setIsOpen(false);
  };

  const currentYear = new Date().getFullYear();
  const numberOfFutureYears = 10; // Adjust this value based on how many future years you want to include

  const generateYearOptions = () => {
    const years = [];
    for (let i = 0; i <= numberOfFutureYears; i++) {
      years.push(currentYear + i);
    }
    return years;
  };

  const [selectedYear, setSelectedYear] = useState(currentYear);

  const handleYearChange = (event) => {
    setSelectedYear(event.target.value);
  };

  let userData = sessionStorage.getItem("lssbAdminData");
  userData = JSON.parse(userData);

  const fetchProfile = async (page) => {
    let res = await LSSB.make_API_call({
      $k: userData.token,
      _endpoint: "fetch_users",
      $where: { _id: "$self" },
    });

    return res;
  };
  const profileQuery = useQuery(["profile"], () => fetchProfile());


  let profileData = profileQuery.data?.data?.data || [];

  return (
    <div>
      <div className="border-t border-b  border-[#D6DDEB] rounded-lg p-[18px] md:p-[24px] xl:p-[32px]">
        <div className="px-[16px] md:px-[32px] xl:px-[43px] py-[24px] md:py-[42px] xl:py-[70px] flex flex-wrap items-center gap-[16px] md:gap-[24px] xl:gap-[32px] bg-[#F8F8FD] ">
          {profileData?._fields?.image ? (
            <img
              src={profileData?._fields?.image}
              alt="profile"
              className="h-[60px] w-[60px] md:h-[80px] md:w-[80px] xl:h-[100px] xl:w-[100px] rounded-full"
            />
          ) : (
            <ProfileCircle size="60" color="#7e828b" variant="Bulk" />
          )}

          <div className="flex-1">
            <h3 className="text-[18px] md:text-[24px] xl:text-[28px] mb-1 md:mb-2 font-medium text-[#25324B]">
              {profileData?._fields?.fullname}
            </h3>
            <p className="text-md md:text-base xl:text-lg text-[#515B6F] ">
              {profileData?._fields?.email}
            </p>
          </div>

          {/* <button className="w-[140px] md:w-[220px] xl:w-[242px] py-[10px] md:py-[14px] bg-[#25324B] text-center ">
            <p className="text-white text-md md:text-lg  ">Change Photo</p>
          </button> */}
        </div>
      </div>
      <ul className="border mb-5  mx-4 md:mx-6 rounded-md px-3 py-3 mt-5 grid grid-cols-2 items-start gap-x-5 gap-y-5">
        <li className="mb-2">
          <h2 className="text-sm mb-1 capitalize text-[black] font-[500]">
            Full Name:{" "}
          </h2>
          <p className="text-sm">
            {" "}
            {profileData?._fields?.fullname || "-- || --"}
          </p>
        </li>
        <li className="mb-2">
          <h2 className="text-sm mb-1 capitalize text-[black] font-[500]">
            Username:{" "}
          </h2>
          <p className="text-sm">
            {" "}
            {profileData?._fields?.username || "-- || --"}
          </p>
        </li>

        <li className="mb-2">
          <h2 className="text-sm mb-1 capitalize text-[black] font-[500]">
            Email Address:{" "}
          </h2>
          <p className="text-sm">
            {" "}
            {profileData?._fields?.email || "-- || --"}
          </p>
        </li>

        <li className="mb-2">
          <h2 className="text-sm mb-1 capitalize text-[black] font-[500]">
            {" "}
            LASRRA:
          </h2>
          <p className="text-xs">
            {" "}
            {profileData?._fields?.lassra || "-- || --"}
          </p>
        </li>

        {/* <li className="mb-2">
          <h2 className="text-sm mb-1 capitalize text-[black] font-[500]">
            {" "}
            Local government of Origin:
          </h2>
          <p className="text-xs">
            {" "}
            {profileData?._fields?.stateOfOrigin || "-- || --"}
          </p>
        </li> */}

        <li className="mb-2">
          <h2 className="text-sm mb-1 capitalize text-[black] font-[500]">
            Date of Birth
          </h2>
          <p className="text-sm">{profileData?._fields?.dob || "-- || --"}</p>
        </li>

        <li className="mb-1">
          <h2 className="text-sm mb-1 capitalize text-[black] font-[500]">
            Residential Address
          </h2>
          <p className="text-sm">{profileData?._fields?.address}</p>
        </li>

        <li className="mb-1">
          <h2 className="text-sm mb-1 capitalize text-[black] font-[500]">
            Phone Number
          </h2>
          <p className="text-sm">{profileData?._fields?.phone_no}</p>
        </li>
        <li className="mb-1">
          <h2 className="text-sm mb-1 capitalize text-[black] font-[500]">
            Gender
          </h2>
          <p className="text-sm">{profileData?._fields?.sex}</p>
        </li>

        <li className="mb-1">
          <h2 className="text-sm mb-1 capitalize text-[black] font-[500]">
            Division{" "}
          </h2>
          <p className="text-sm">{profileData?._fields?.division}</p>
        </li>

        {/* <li className="mb-1">
        <h2 className="text-sm mb-1 capitalize text-[black] font-[500]">
        Account Number
          </h2>
          <p className="text-sm">
            {profileData?._fields?.account_number || "-- || --"}
          </p>
        </li>

        <li className="mb-1">
        <h2 className="text-sm mb-1 capitalize text-[black] font-[500]">
       Account Name
          </h2>
          <p className="text-sm">
            {profileData?._fields?.account_name || "-- || --"}
          </p>
        </li>

        <li className="mb-1">
        <h2 className="text-sm mb-1 capitalize text-[black] font-[500]">
        Bank Name
          </h2>
          <p className="text-sm">
            {profileData?._fields?.bank_Name || "-- || --"}
          </p>
        </li>
        */}
      </ul>

      <Modal isOpen={isOpen} onClose={handleCloseModal}>
        <div className="inline-block relative  p-[18px] md:p-[24px] xl:p-[32px] overflow-hidden text-left align-bottom transition-all transform bg-[white]   shadow-xl sm:my-8 sm:align-middle w-full min-w-[360px] md:min-w-[450px] md:max-w-[750px] ">
          <h2 className="text-[20px] md:text-[24px] xl:text-[28px] text-center font-normal leading-[35px] text-black mb-[16px] md:mb-[20px] ">
            Update Profile
          </h2>

          <form className=" w-full mt-[20px]">
            <div className="mb-[24px]">
              <label className="text-[14px] md:text-[14px] xl:text-[16px] font-normal leading-[24px] text-[#515B6F] mb-[8px]">
                Select Institution
              </label>
              <div className=" ">
                <select
                  type="text"
                  placeholder="Enter Marital Status"
                  className="w-full h-[50px] px-[16px] py-[12px] text-[14px] text-[#344054] leading-[20px] bg-[#F7F9FC] placeholder:text-[#98A2B3] placeholder:text-[12px]  border-[#D6DDEB] border-[1px]  focus:outline-none focus:ring-[#AF8544] focus:border-[#AF8544] "
                  required
                  autoComplete="on"
                  name="maritalStatus"
                  // value={idType}
                  // onChange={(event) => {setIdType(event.target.value)}}
                  autoCapitalize="off"
                  autoCorrect="off"
                  spellCheck="false"
                >
                  <option value="">Select University</option>
                  {University &&
                    University.map((uni, index) => (
                      <option value={uni.value}>{uni.text}</option>
                    ))}
                </select>
              </div>
            </div>
            <div className="mb-[24px]">
              <label className="text-[14px] md:text-[14px] xl:text-[16px] font-normal leading-[24px] text-[#515B6F] mb-[8px]">
                Qualification in view
              </label>
              <div className=" ">
                <select
                  type="text"
                  placeholder="Enter Marital Status"
                  className="w-full h-[50px] px-[16px] py-[12px] text-[14px] text-[#344054] leading-[20px] bg-[#F7F9FC] placeholder:text-[#98A2B3] placeholder:text-[12px]  border-[#D6DDEB] border-[1px]  focus:outline-none focus:ring-[#AF8544] focus:border-[#AF8544] "
                  required
                  autoComplete="on"
                  name="maritalStatus"
                  // value={idType}
                  // onChange={(event) => {setIdType(event.target.value)}}
                  autoCapitalize="off"
                  autoCorrect="off"
                  spellCheck="false"
                >
                  <option value="">Select Qualification</option>
                  <option value="Bachelor">Bachelor</option>
                  <option value="Masters">Masters</option>
                  <option value="PHD">PHD</option>
                </select>
              </div>
            </div>
            <div className="mb-[24px]">
              <label className="text-[14px] md:text-[14px] xl:text-[16px] font-normal leading-[24px] text-[#515B6F] mb-[8px]">
                Enter Course of Study
              </label>
              <div className=" ">
                <input
                  type="text"
                  placeholder=" Enter course of study"
                  className="w-full h-[50px] px-[16px] py-[12px] text-[14px] text-[#344054] leading-[20px] bg-[#F7F9FC] placeholder:text-[#98A2B3] placeholder:text-[12px]  border-[#D6DDEB] border-[1px]  focus:outline-none focus:ring-[#AF8544] focus:border-[#AF8544] "
                  required
                  autoComplete="on"
                  name=""
                  // value={idNumber}
                  // onChange={(e) => {setIdNumber(e.target.value);}}
                  autoCapitalize="off"
                  autoCorrect="off"
                  spellCheck="false"
                />
              </div>
            </div>
            <div className="mb-[24px]">
              <label className="text-[14px] md:text-[14px] xl:text-[16px] font-normal leading-[24px] text-[#515B6F] mb-[8px]">
                Enter Matric Number
              </label>
              <div className=" ">
                <input
                  type="text"
                  placeholder=" Enter matric no"
                  className="w-full h-[50px] px-[16px] py-[12px] text-[14px] text-[#344054] leading-[20px] bg-[#F7F9FC] placeholder:text-[#98A2B3] placeholder:text-[12px]  border-[#D6DDEB] border-[1px]  focus:outline-none focus:ring-[#AF8544] focus:border-[#AF8544] "
                  required
                  autoComplete="on"
                  name=""
                  // value={idNumber}
                  // onChange={(e) => {setIdNumber(e.target.value);}}
                  autoCapitalize="off"
                  autoCorrect="off"
                  spellCheck="false"
                />
              </div>
            </div>
            <div className="mb-[24px]">
              <label className="text-[14px] md:text-[14px] xl:text-[16px] font-normal leading-[24px] text-[#515B6F] mb-[8px]">
                Expected Year of Graduation
              </label>
              <div className=" ">
                <select
                  id="year-selector"
                  className="w-full h-[50px] px-[16px] py-[12px] text-[14px] text-[#344054] leading-[20px] bg-[#F7F9FC] placeholder:text-[#98A2B3] placeholder:text-[12px]  border-[#D6DDEB] border-[1px]  focus:outline-none focus:ring-[#AF8544] focus:border-[#AF8544] "
                  value={selectedYear}
                  onChange={handleYearChange}
                >
                  {generateYearOptions().map((year) => (
                    <option key={year} value={year}>
                      {year}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <button
              type="submit"
              className="w-full py-[14px] text-center text-white bg-[#AF8544]  flex items-center justify-center mb-[20px] md:mb-[32px]"
            >
              <p className="text-sm font-medium leading-[20px]">Continue</p>
            </button>
          </form>
        </div>
      </Modal>
    </div>
  );
};

export default MyProfile;
